import logo from "./logo.svg";
import "./App.css";
// import Analysis from "./view/analysis/Analysis";
// import Details from "./view/details/Details";
// import InventoryDay from "./view/inventoryDay/InventoryDay";
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import routes from "./router/index";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          {/* <Route path="/" element={<Navigate to="/analysis" replace />}>
          </Route> */}
          {routes.map((routers, index) =>
            (routers.children && routers.children.length >= 1) ? (
              routers.children.map((routes2, index2) => (
                <Route
                  key={index2}
                  exact
                  path={routes2.path}
                  element={<routes2.component />}
                />
              ))
            ) : (
              <Route
                key={index}
                exact
                path={routers.path}
                element={<routers.component />}
              />
            )
          )}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
